import { Component, EventEmitter, Input, Output, ViewChildren } from '@angular/core';
import { SenderID, ExtendedDomain } from '../shared-types';
import { DomainInfoCardComponent } from '../domain-info-card/domain-info-card.component';

@Component({
  selector: 'email-domains',
  templateUrl: './domains.component.html',
  styleUrls: ['./domains.component.scss'],
  standalone: false,
})
export class DomainsComponent {
  @Input() readonly senderId: SenderID;
  @Input() readonly domains: ExtendedDomain[] = [];
  @Input() readonly deleteInProgress = false;
  @Input() readonly showEmpty = true;

  @Output() readonly deleteRequested = new EventEmitter<string>();
  @Output() readonly authorizeRequested = new EventEmitter<null>();
  @Output() readonly useAsDefaultRequested = new EventEmitter<string>();

  @ViewChildren(DomainInfoCardComponent) domainInfoCards: DomainInfoCardComponent[];

  async handleAuthorizeClick(): Promise<void> {
    this.authorizeRequested.emit(null);
  }

  scrollToDomain(domain: string): void {
    this.domainInfoCards
      .filter((c) => c.domain?.sendFromDomain === domain)
      .forEach((card) => {
        card.expanded = true;
      });
    // WARNING: if an error happens and the domain is not found, this would break the page
    // We need to handle if the element is not found. Refer to UB-397
    // Consider if the element is not found to debounce until it is found. For now we will just not scroll.
    window.setTimeout(
      () => document.getElementById(`domain_card_${domain}`)?.scrollIntoView({ behavior: 'smooth' }),
      500,
    );
  }
}
